import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/ArrowLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/app/src/i18n/navigation.tsx");
